import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=4e227941&"
import script from "./orderHistory.vue?vue&type=script&lang=js&"
export * from "./orderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports